import { useRef, useCallback, useEffect } from "react";

export const useAutoGrowTextArea = (props: { promptText?: string }) => {
    const { promptText } = props;

    const textAreaHolderRef = useRef<HTMLDivElement>(null);

    const handleTextAreaChange = useCallback(() => {
        if (textAreaHolderRef.current) {
            textAreaHolderRef.current.dataset.replicatedValue = promptText;
        }
    }, [promptText]);

    useEffect(() => {
        handleTextAreaChange();
    }, [handleTextAreaChange]);

    return { textAreaHolderRef, handleTextAreaChange };
};
